import { authStateOption } from "../../const";

export const getSonicosAuthStatus = (result) => {
  if (result?.status === "failed" && result?.error?.kind === "AuthenticationRejected") {
    return authStateOption.failed;
  }
  if (result?.deviceIPAddress && !result?.error) {
    return authStateOption.passed;
  }
  return null;
};
